import React, { useMemo, useState } from "react";
import PropTypes from "prop-types";
import moment from "moment";
import "react-dates/initialize";
import { SingleDatePicker } from "react-dates";
import "react-dates/lib/css/_datepicker.css";
import { uniqueId } from "lodash";

const DatePickerForSingle = ({
    id: id_,
    date,
    displayFormat,
    valueType: valueType_,
    format,
    numberOfMonths,
    small,
    onDateChange,
    showDefaultInputIcon,
    inputIconPosition,
    isOutsideRange,
    ...otherProps
}) => {
    const [focused, setFocused] = useState(false);
    const [id] = useState(id_ || `single_date_input_${uniqueId()}`);
    const valueType = useMemo(() => valueType_?.toLowerCase(), [valueType_]);

    return (
        <SingleDatePicker
            {...otherProps}
            id={id}
            date={date && moment(date)}
            focused={focused}
            displayFormat={displayFormat}
            numberOfMonths={numberOfMonths}
            small={small}
            showDefaultInputIcon={showDefaultInputIcon}
            inputIconPosition={inputIconPosition}
            isOutsideRange={isOutsideRange}
            onDateChange={(date) => {
                let date_ = date;
                if (valueType === "string") date_ = date?.format(format);
                if (onDateChange) onDateChange(date_);
            }}
            onFocusChange={({ focused }) => setFocused(focused)}
        />
    );
};

DatePickerForSingle.propTypes = {
    id: PropTypes.string,
    date: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    disabled: PropTypes.bool,
    numberOfMonths: PropTypes.number,
    small: PropTypes.bool,
    showDefaultInputIcon: PropTypes.bool,
    displayFormat: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    valueType: PropTypes.string,
    format: PropTypes.string,
    anchorDirection: PropTypes.string,
    inputIconPosition: PropTypes.string,
    placeholder: PropTypes.string,
    isOutsideRange: PropTypes.func,
    onDateChange: PropTypes.func,
};

DatePickerForSingle.defaultProps = {
    disabled: false,
    numberOfMonths: 1,
    small: true,
    showDefaultInputIcon: true,
    valueType: "string",
    format: "YYYY-MM-DD",
    displayFormat: "YYYY-MM-DD",
    inputIconPosition: "before",
    anchorDirection: "right",
    placeholder: "Date",
    isOutsideRange: () => false,
};

export default DatePickerForSingle;
